import { DATA_SHOP } from './actionTypes';

export const setReduxDataShop = (data) => {
  return {
    type: DATA_SHOP,
    data,
  };
};
